export default "__VITE_ASSET__2fd62f54__"